import { InfoboxProps, PushpinProps } from '../../types/MapModels';
import StopSelectionPopupContent from './StopSelectionPopupContent';

interface StopPushpinOptions {
    location: CoordinatePair;
    selected?: boolean;
    onClick?: () => void;
}

interface StopSelectionPopupOptions {
    location: CoordinatePair;
    stopId: string;
    stopName: string;
    isFromActive?: boolean;
    isToActive?: boolean;
    onSelectFrom: () => void;
    onSelectTo: () => void;
}

interface StopInfoPopupOptions {
    location: CoordinatePair;
    label: string;
    visible?: boolean;
    offset?: [number, number];
}

export const DEFAULT_STOP_POPUP_OFFSET: [number, number] = [0, -15];

export function createStopPushpin({
    location,
    selected = false,
    onClick,
}: StopPushpinOptions): PushpinProps {
    const eventHandlers = !onClick
        ? []
        : [{
            event: 'click' as const,
            callback: () => onClick(),
        }];

    return {
        location,
        options: {
            icon: selected
                ? 'stopSelectedIcon'
                : 'stopIcon',
            catId: 'bus-stop',
        },
        eventHandlers,
    };
}

export function createStopSelectionInfobox({
    location,
    stopId,
    stopName,
    isFromActive = false,
    isToActive = false,
    onSelectFrom,
    onSelectTo,
}: StopSelectionPopupOptions): InfoboxProps {
    return {
        location,
        title: `${stopName} (${stopId})`,
        text: (
            <StopSelectionPopupContent
                isFromActive={isFromActive}
                isToActive={isToActive}
                onSelectFrom={onSelectFrom}
                onSelectTo={onSelectTo}
            />
        ),
        options: {
            offset: DEFAULT_STOP_POPUP_OFFSET,
            showCloseButton: false,
        },
    };
}

export function createStopInfoInfobox({
    location,
    label,
    visible = false,
    offset = DEFAULT_STOP_POPUP_OFFSET,
}: StopInfoPopupOptions): InfoboxProps {
    return {
        location,
        options: {
            description: label,
            visible,
            offset,
            showCloseButton: false,
        },
    };
}
